import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Component Pages

import { HomeLandingComponent } from './pages/home/home-landing.component';
import { InstitutionComponent } from './layout/institutionpage/institution.component';
import { TeacherComponent } from './layout/teacherpage/teacher.component';
import { AboutPageComponent } from './layout/aboutpage/aboutpage.component';
import { ContactPageComponent } from './layout/contactpage/contactpage.component';
import { ParentComponent } from './layout/parentpage/parent.component';
import { StudentComponent } from './layout/studentpage/student.component';
import { PrivacyPageComponent } from './layout/privacypage/privacypage.component';
import { TermsPageComponent } from './layout/termspage/termspage.component';


const routes: Routes = [
  {
       path: '', component: HomeLandingComponent 
  },
  {
    path: 'institution', component: InstitutionComponent 
  },
  {
    path: 'teacher', component: TeacherComponent 
  },
  {
    path: 'student', component: StudentComponent 
  },

  {
    path: 'parent', component: ParentComponent 
  },

  {
    path: 'contact-us', component: ContactPageComponent 
  },
  {
    path: 'about-us', component: AboutPageComponent 
  },

  {
    path: 'privacy-policy', component: PrivacyPageComponent 
  },
  {
    path:'terms-conditions', component: TermsPageComponent
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class LandingRoutingModule { }
